module.exports = __webpack_public_path__ + "img/dp_lp_pc_top_logo.effff6f4.png";